import template from './trip-item-bus.html';

const DIRECTIVE_NAME = TripItemBus.DIRECTIVE_NAME = 'ktTripItemBus';
export default function TripItemBus() {
    return {
        restrict: 'A',
        template,
        scope: {
            bus: `=${DIRECTIVE_NAME}`,
            isCheckout: `=${DIRECTIVE_NAME}IsCheckout`,
        },
        bindToController: true,
        controller: TripItemBusController,
        controllerAs: '$ctrl',
        link: function($scope, $elem, $attrs, $ctrl) {
            $ctrl.$onInit();
        },
    };
}

export function TripItemBusController(
    userService,
    tripItemBusService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        vm.fromToRoute = tripItemBusService.getFromToRoute(vm.bus);
        vm.departureDate = tripItemBusService.getDepartureDate(vm.bus);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-bus/trip-item-bus-component.js